import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'
import { history } from 'src/core/router'

export default class {
  @observable data = {
    uid: 0,
    userInfo: {},
    activeInfo: {},
    giftinfo: {},
    gameinfo: {},
    micinfo: {},
  }


  @action async setUid(uid) {
    this.data.uid = uid || 0
  }

  //用户信息
  @action async getData(map) {
    let d = await http.post('/web/MyAccountInfo', map)
    if (d.code == 0) {
      this.data.userInfo = d.res
    }
    let activeInfo = await http.post('/web/active/activeInfo', map)
    if (activeInfo.code == 0) {
      this.data.activeInfo = activeInfo.res
    }
    let expinfo = await http.post('/web/active/dailyMission', map)
    if (activeInfo.code == 0) {
      expinfo && expinfo.res && expinfo.res.forEach(item => {
        if (item.activeType == 1) {
          this.data.micinfo = item
        } else if (item.activeType == 2) {
          this.data.gameinfo = item
        } else if (item.activeType == 3) {
          this.data.giftinfo = item
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// src/store/activity/level.js